const Dashboard = () => System.import('./components/dashboard/Dashboard');

const Registers = () => System.import('./components/registers/Registers');
const Register = () => System.import('./components/registers/Register');
const RegisterSave = () => System.import('./components/registers/RegisterSave');

const Institutions = () => System.import('./components/institutions/Institutions');
const Institution = () => System.import('./components/institutions/Institution');
const InstitutionSave = () => System.import('./components/institutions/InstitutionSave');

const CourseSave = () => System.import('./components/course/CourseSave');

const Students = () => System.import('./components/students/Students');
const Student = () => System.import('./components/students/Student');

const Books = () => System.import('./components/books/Books');
const Book = () => System.import('./components/books/Book');

const Users = () => System.import('./components/users/Users');
const User = () => System.import('./components/users/User');
const UserSave = () => System.import('./components/users/UserSave');
const UserPass = () => System.import('./components/users/UserPass');

const Login = () => System.import('./components/users/Login');
const Logout = () => System.import('./components/users/Logout');
const Password = () => System.import('./components/users/Password');
const Recover = () => System.import('./components/users/UserRecover');

const ProcessRegister = () => System.import('./components/process/ProcessRegister');
const ProcessStudent = () => System.import('./components/process/ProcessStudent');

export const routes = [{
    path: '/',
    name: 'login',
    component: Login,
    title: 'Login',
    menu: false
  },
  {
    path: '/painel',
    name: 'dashboard',
    component: Dashboard,
    title: 'Painel',
    menu: true,
    icon: 'fa fa-tachometer'
  },
  {
    path: '/graduados',
    name: 'students',
    component: Students,
    title: 'Graduados',
    menu: true,
    icon: 'fa fa-graduation-cap'
  },
  {
    path: '/graduados/:id',
    name: 'students-details',
    component: Student,
    title: 'Graduados',
    menu: false,
  },
  {
    path: '/graduados/processo',
    name: 'process-student',
    component: ProcessStudent,
    title: 'Processo do Graduado',
    menu: false,
  },
  {
    path: '/registros',
    name: 'registers',
    component: Registers,
    title: 'Registros',
    menu: true,
    icon: 'fa fa-address-book'
  },
  {
    path: '/registros/salvar',
    name: 'register-save',
    component: RegisterSave,
    title: 'Registrar',
    menu: false
  },
  {
    path: '/registros/processo',
    name: 'register-process',
    component: ProcessRegister,
    title: 'Processo',
    props: true,
    menu: false
  },
  {
    path: '/registros/:id',
    name: 'registers-details',
    component: Register,
    title: 'Registro',
    menu: false
  },
  {
    path: '/instituicoes',
    name: 'institutions',
    component: Institutions,
    title: 'Instituições',
    menu: true,
    icon: 'fa fa-university'
  },
  {
    path: '/instituicoes/salvar',
    name: 'institution-save',
    component: InstitutionSave,
    title: 'Instituição',
    menu: false
  },
  {
    path: '/instituicoes/:id',
    name: 'institutions-details',
    component: Institution,
    title: 'Instituição',
    menu: false
  },
  {
    path: '/cursos/salvar',
    name: 'course-save',
    component: CourseSave,
    title: 'Curso',
    props: true,
    menu: false
  },
  {
    path: '/livros',
    name: 'books',
    component: Books,
    title: 'Livros',
    menu: true,
    icon: 'fa fa-book'
  },
  {
    path: '/livros/:id',
    name: 'books-details',
    component: Book,
    title: 'Livros',
    menu: false,
    icon: 'fa fa-book'
  },
  {
    path: '/usuarios',
    name: 'users',
    component: Users,
    title: 'Usuários',
    menu: (localStorage.getItem('level') == 1 || localStorage.getItem('level') == 2) ? true : false,
    icon: 'fa fa-users'
  },
  {
    path: '/usuarios/salvar',
    name: 'users-save',
    component: UserSave,
    props: true,
    title: 'Usuário',
    menu: false
  },
  {
    path: '/usuarios/password',
    name: 'users-pass',
    component: UserPass,
    props: true,
    title: 'Usuário',
    menu: false
  },
  {
    path: '/usuarios/:id',
    name: 'users-details',
    component: User,
    title: 'Usuário',
    menu: false
  },
  {
    path: '/usuarios/senha/:hash',
    name: 'password',
    component: Password,
    title: 'Senha',
    menu: false,
  },
  {
    path: '/usuarios/recuperar',
    name: 'recover',
    component: Recover,
    title: 'Recuperar senha',
    menu: false,
  },
  {
    path: '/sair',
    name: 'logout',
    component: Logout,
    title: 'Sair',
    menu: true,
    icon: 'fa fa-sign-out'
  },
  {
    path: '*',
    component: Dashboard,
    menu: false
  }
];



// WEBPACK FOOTER //
// ./src/routes.js